import { BASE_URL, API_KEY } from "../../config/global";
import createClient from "./Base";

const client = createClient({
  baseUrl: BASE_URL,
  headers: {
    "API-KEY": API_KEY
  },
});

export { client };
